import { achievementsModalActionTypes } from './Constants';

export function toggleAchievementsModal(data) {
	return {
		type: achievementsModalActionTypes.TOGGLE_ACHIEVEMENTS_MODAL,
		payload: { data },
	};
}

export function getAchievement(username, achievementId) {
	return {
		type: achievementsModalActionTypes.GET_ACHIEVEMENT_DATA,
		payload: { username, achievementId },
	};
}

export function getAchievementSuccess(data) {
	return {
		type: achievementsModalActionTypes.GET_ACHIEVEMENT_DATA_SUCCESS,
		payload: { data },
	};
}

export function getAchievementError() {
	return {
		type: achievementsModalActionTypes.GET_ACHIEVEMENT_DATA_ERROR,
	};
}

export function highlightAchievement(achievementId, achievementTitle, callback) {
	return {
		type: achievementsModalActionTypes.HIGHLIGHT_ACHIEVEMENT,
		payload: { achievementId, achievementTitle, callback },
	};
}

export function highlightAchievementSuccess(data) {
	return {
		type: achievementsModalActionTypes.HIGHLIGHT_ACHIEVEMENT_SUCCESS,
		payload: { data },
	};
}

export function highlightAchievementError(data) {
	return {
		type: achievementsModalActionTypes.HIGHLIGHT_ACHIEVEMENT_ERROR,
		payload: { data },
	};
}

export function clearState() {
	return {
		type: achievementsModalActionTypes.CLEAR_ACHIEVEMENT_MODAL_STATE,
	};
}
